import { MutationTree } from 'vuex';
import { AuthState } from './types';

export const mutations: MutationTree<AuthState> = {
    authRequest: (state) => {
        state.status = 'loading'
    },
    authSuccess: (state) => {
        state.status = 'success';
        state.isAuthenticated = true
    },
    authError: (state) => {
        state.status = 'error'
    },
    authLogout: (state) => {
        state.isAuthenticated = false
    },
    setChangePassword: (state, val) => {
        state.isNeedChangePassword = val
    },
    setUsername: (state, val) => {
        state.username = val
    },
    setModerationSettings: (state, val) => {
        state.moderationSettings = val
    },
    setIsADUser: (state, val) => {
        state.isADUser = val
    },
};